// @flow

import moment from 'moment'
import Cookies from 'js-cookie'

import {
  CS_SEARCH_QUERY_ON_CHANGE,
  GET_RECENT_POLICIES_BY_CLAIM_STATUS_SUCCESS,
  GET_RECENT_POLICIES_BY_CLAIM_STATUS_FAILED,
  GET_UNLINKED_WAREHOUSE_RECORDS_SUCCESS,
  GET_UNLINKED_WAREHOUSE_RECORDS_FAILED,
  START_DATE_ON_CHANGE,
  END_DATE_ON_CHANGE,
  SEARCH_ZHONGAN_POLICY_SUCCESS,
  SEARCH_ZHONGAN_POLICY_FAILED,
  SEARCH_SLAB_POLICY_SUCCESS,
  SEARCH_SLAB_POLICY_FAILED,
} from '../constants'

type State = {
  query: string,
  recentPolicy: Array<{}>,
  storeNames: any,
  unlinkedWarehouseRecords: Array<{}>,
  error: string,
  startDate: ?string,
  endDate: ?string,
  zhonganPolicies: Array<any>,
  sLabPolicies: Array<any>,
  totalResults: number,
}

const initialState = {
  query: '',
  recentPolicy: [],
  unlinkedWarehouseRecords: [],
  error: '',
  storeNames: {},
  startDate: Cookies.get('startDate') ? moment(Cookies.get('startDate')) : moment().subtract(7, 'd'),
  endDate: Cookies.get('endDate') ? moment(Cookies.get('endDate')) : moment(),
  zhonganPolicies: [],
  sLabPolicies: [],
  totalResults: 0,
}

function customerService(state: State = initialState, action: { type: string, payload: any }) {
  switch (action.type) {
    case CS_SEARCH_QUERY_ON_CHANGE:
      console.log(1);
      return {
        ...state,
        query: action.payload
      }
    case GET_RECENT_POLICIES_BY_CLAIM_STATUS_SUCCESS:
      return {
        ...state,
        recentPolicy: action.payload.result.policies,
        storeNames: action.payload.result.entities.reduce((previous, current) => {
          return {
            ...previous,
            [current.entityId]: current.storeName
          }
        }, {})
      }
    case GET_RECENT_POLICIES_BY_CLAIM_STATUS_FAILED:
      return {
        ...state,
        error: action.payload
      }
    case GET_UNLINKED_WAREHOUSE_RECORDS_SUCCESS:
      return {
        ...state,
        unlinkedWarehouseRecords: action.payload.result.warehouseRecords
      }
    case GET_UNLINKED_WAREHOUSE_RECORDS_FAILED:
      return {
        ...state,
        error: action.payload
      }
    case START_DATE_ON_CHANGE:
      return {
        ...state,
        startDate: action.payload
      }
    case END_DATE_ON_CHANGE:
      return {
        ...state,
        endDate: action.payload
      }
    case SEARCH_ZHONGAN_POLICY_SUCCESS:
      return {
        ...state,
        zhonganPolicies: action.payload.policies,
        totalResults: action.payload.total
      }
    case SEARCH_ZHONGAN_POLICY_FAILED:
      return {
        ...state,
        error: action.payload,
        zhonganPolicies: [],
        totalResults: 0
      }
    case SEARCH_SLAB_POLICY_SUCCESS:
      return {
        ...state,
        sLabPolicies: action.payload.policies,
        totalResults: action.payload.total
      }
    case SEARCH_SLAB_POLICY_FAILED:
      return {
        ...state,
        error: action.payload,
        sLabPolicies: [],
        totalResults: 0
      }
    default:
      return state
  }
}

export default customerService



// WEBPACK FOOTER //
// ./src/modules/customerService.js